import {HttpClient} from "@angular/common/http";
import {Component, EventEmitter, Inject, Input, NgZone, OnInit, Output} from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { environment } from "../../../../../../../environments/environment";
import { DocumentType } from "../../../../../../models/document-type";
import { Registration } from "../../../../../../models/registration";
import { Requirement } from "../../../../../../models/requirement";
import { DocumentRequirementControllerService } from "../../../../../../services/requirement-controller/document-requirement-controller.service";
import { RequirementControllerService } from "../../../../../../services/requirement-controller/requirement-controller.service";
import { RequirementService } from "../../../../../../services/requirement-controller/requirement.service";
import { ServiceControllerService } from "../../../../../../services/service-controller/service-controller.service";
import { Store } from "../../../../../../services/store.service";
import {TranslatedBaseError} from "../../../../TranslatedBaseError";
import {TranslateService} from "@ngx-translate/core";
import {BotControllerService} from "../../../../../../services/role-controller/bot-controller.service";
import {Bot} from "../../../../../../models/bot";
import {DocumentRequirement} from "../../../../../../models/document-requirement";
import {DocumentRequirementField} from "../../../../../../models/document-requirement_field";
import {CdkDragDrop, moveItemInArray} from "@angular/cdk/drag-drop";
import {forkJoin, Observable} from "rxjs";

@Component({
  selector: "requirement-edit",
  templateUrl: "./requirement-edit.component.html",
  styles: [],
  providers: [ToastrService, DocumentRequirementControllerService, BotControllerService],
})
export class RequirementEditComponent extends TranslatedBaseError implements OnInit {

  @Input() public serviceId: string;
  @Input() public registration: Registration;
  @Input() public documentRequirement: DocumentRequirement;
  @Input() public requirement: Requirement = new Requirement();
  @Input() public addNew: boolean = false;
  @Input() public determinantMapById: { [key: string]: string };
  @Output() public formSubmit = new EventEmitter();
  @Output() public editCancel = new EventEmitter();
  public baseUrl = environment.BASE_URL;
  public showDeterminantBuilder: boolean = false;
  public analysing: boolean = false;
  public checkErrors: boolean = false;
  public newDocumentType: string;
  public availableDocumentBots: Bot[] = [];

  public fieldTypes = ["textfield", "textarea", "number", "checkbox", "selectboxes", "select", "radio", "email", "url", "phoneNumber", "currency", "datetime", "day", "time", "file", "signature"];

  public documentRequirementFields: DocumentRequirementField[] = [];
  public documentRequirementField: DocumentRequirementField = new DocumentRequirementField();

  public isDbSource: boolean = false;

  public subscription: any;
  public isLoading: boolean = false;

  constructor(public toastr: ToastrService,
              private http: HttpClient,
              private documentRequirementService: DocumentRequirementControllerService,
              protected requirementControllerService: RequirementControllerService,
              private botControllerService: BotControllerService,
              protected serviceController: ServiceControllerService,
              @Inject(NgZone) protected zone: NgZone,
              private requirementService: RequirementService,
              public store: Store, public translateService: TranslateService) {
    super(toastr, translateService);
  }

  public ngOnInit(): void {
    this.newDocumentType = "";
    this.subscription = this.requirementService.editData.subscribe((data: any) => {
      console.log("--- requirement Edit", data);
      this.serviceId = data.serviceId;
      this.registration = data.registration;
      this.documentRequirement = data.documentRequirement;
      this.requirement = data.requirement;
      this.addNew = data.addNew;
      this.showDeterminantBuilder = data.showDeterminantBuilder;
      this.documentRequirement.toUpload = this.addNew ? true : data.documentRequirement.toUpload;
      if (this.documentRequirement?.id && this.documentRequirement?.usedAsADatabase && this.documentRequirement?.templateUrl) {
        this.getDocumentFields(this.documentRequirement.id);
      }

      this.botControllerService.getServiceBots(this.serviceId).subscribe((bots) => {
        this.availableDocumentBots = bots
          .filter((bot) => bot.botType === "document" && bot.category === "document_generate_and_upload")
          .map((bot) => {
            const bt = new Bot();
            bt.id = bot.id;
            bt.name = bot.name;
            bt.botType = bot.botType;
            if (bt.id === (this.documentRequirement.bot && this.documentRequirement.bot.id)) {
              this.documentRequirement.bot = bt;
            }
            return bt;
          });
      });
    });
  }

  public ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  public getDocumentFields(id: string) {
    this.analysing = true;
    this.documentRequirementService.getRegistrationRequirementFields(id).subscribe(
      (fields) => {
        this.analysing = false;
        this.documentRequirementFields = fields
          .filter((field) => field.id !== null && field.fieldName !== null && field.fieldName !== "")
          .sort((a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0));
        this.documentRequirement.fields = this.documentRequirementFields;
      },
      (error) => {
        this.analysing = false;
        this.showErrorMessage(error);
      },
    );
  }

  public updateDocumentRequirementField(item: DocumentRequirementField) {
    this.saveDocumentRequirement(false);
    /*
    this.documentRequirementService.saveRegistrationRequirementField(item).subscribe(
      () => {
        this.responseSuccessful("Field is updated!");
      },
      (error) => this.showErrorMessage(error),
    );
    */
  }
  public saveDocumentRequirementField(item: DocumentRequirementField) {
    if (item.fieldName == null || item.fieldName === "") {
      this.showErrorMessage("Field name is required!");
      return;
    }
    item.sortOrder = this.documentRequirementFields.length;
    this.documentRequirementService.addRegistrationRequirementField(this.documentRequirement.id, item).subscribe(
      (data) => {
        this.responseSuccessful("Field is saved!");
        const newField = data as DocumentRequirementField;
        newField.sortOrder = newField.sortOrder ?? this.documentRequirementFields.length;
        this.documentRequirementFields.push(newField);
        this.documentRequirementFields.sort((a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0));
        this.documentRequirement.fields = [...this.documentRequirementFields];
        this.documentRequirementField = new DocumentRequirementField();
        this.documentRequirementField.id = null;
        this.documentRequirementField.fieldName = null;
        this.documentRequirementField.fieldType = null;
        this.documentRequirementField.workingLabel = null;
      },
      (error) => this.showErrorMessage(error),
    );
  }

  public deleteDocumentRequirementField(item: DocumentRequirementField): void {
    if (!item) {
      return;
    }

    const originalLength = this.documentRequirementFields.length;
    this.documentRequirementFields = this.documentRequirementFields.filter((field) => {
      if (item.id !== undefined && item.id !== null) {
        return field.id !== item.id;
      }
      return field !== item;
    });

    if (this.documentRequirementFields.length === originalLength) {
      return;
    }

    this.documentRequirementFields.forEach((field, index) => {
      field.sortOrder = index;
    });

    this.documentRequirement.fields = [...this.documentRequirementFields];
    this.saveDocumentRequirement(false);
  }

  public onFieldDrop(event: CdkDragDrop<DocumentRequirementField[]>): void {
    if (!event || event.previousIndex === event.currentIndex) {
      return;
    }
    moveItemInArray(this.documentRequirementFields, event.previousIndex, event.currentIndex);
    this.persistDocumentRequirementFieldOrder();
  }

  private persistDocumentRequirementFieldOrder(): void {
    const updates: Observable<any>[] = [];
    this.documentRequirementFields.forEach((field, index) => {
      const currentIndex = index;
      const previousIndex = field.sortOrder ?? index;
      field.sortOrder = currentIndex;
      if (previousIndex !== currentIndex) {
        updates.push(this.documentRequirementService.saveRegistrationRequirementField(field));
      }
    });
    this.documentRequirement.fields = [...this.documentRequirementFields];
    if (!updates.length) {
      return;
    }
    forkJoin(updates).subscribe(
      () => undefined,
      (error) => this.showErrorMessage(error),
    );
  }

  public handleUpload(fileId: string, item: Requirement) {
    // if previous exists then lets remove
    if (item.fileId) {
      this.serviceController.deleteServiceFile(this.serviceId, item.fileId).subscribe(
        () => {
          item.fileId = null;
          this.saveFile(fileId, item);
        },
      );
    } else {
      this.saveFile(fileId, item);
    }
  }

  private saveFile(fileId: string, item: Requirement) {
        if (fileId) {
          item.fileId = fileId;
        }
  }

  public deleteFile(item: Requirement, cb) {
    this.serviceController.deleteServiceFile(this.serviceId, item.fileId).subscribe(
      () => {
        delete item.fileId;
        return cb();
      },
      (error) => this.showErrorMessageWithTitle("File delete error!", error),
    );
  }

  public deleteDefaultCb = () => this.saveRequirement(this.requirement);

  public download(item: Requirement) {
    return this.serviceController.downloadServiceFile(this.serviceId, item.fileId).subscribe((res) => {
      const pdfUrl = (window.URL || (window as any).webkitURL).createObjectURL(new Blob([res], { type: res.type }));
      const anchor = document.createElement("a");
      anchor.href = pdfUrl;
      anchor.setAttribute("download", item.fileId);
      anchor.click();
    });
  }

  public saveRequirement(item: any) {
    this.requirementControllerService.saveRequirement(item).subscribe(
      () => {
        this.responseSuccessful("Requirement is saved!");
        this.requirementService.updateData();
      },
      (error) => this.showErrorMessage(error),
    );
  }

  public saveDocumentRequirement(reset: boolean = true) {
    if (this.registration) {
      this.documentRequirement.registrationId = this.registration.id;
      if (this.documentRequirement.usedAsADatabase && (this.documentRequirement.templateUrl == null || this.documentRequirement.templateUrl === "") && reset) {
        this.documentRequirement.usedAsADatabase = false;
      }
      if (this.isComponentUsedForEditing()) {
        this.documentRequirementService.saveRegistrationRequirement(this.documentRequirement).subscribe(
          (data: any) => {
            console.log("--- saveRegistrationRequirement - data", data);
            this.requirementService.updateData();
            this.responseSuccessful("Requirement is saved!");
            if (reset) {
              this.resetForm();
            }
          }
          ,
          (error) => this.showErrorMessageWithTitle("Error HTTP Post Service!", error),
          () => this.isLoading = false,
        );
      }
      if (this.isComponentUsedForAdding()) {
        this.documentRequirement.requirementId = this.requirement.id;
        this.documentRequirementService.addRegistrationRequirement(this.registration.id, this.documentRequirement).subscribe(
          (data: any) => {
            console.log("--- addRegistrationRequirement - data", data);
            this.requirementService.updateData();
            this.responseSuccessful("Requirement is added!");
            if (reset) {
              this.resetForm();
            }
          },
          (error) => this.showErrorMessageWithTitle("Error HTTP Post Service!", error),
          () => this.isLoading = false,
        );
      }
    }
  }

  private sanitizeRequirementName() {
    if (this.documentRequirement && this.documentRequirement.requirement && this.documentRequirement.requirement.name) {
      this.documentRequirement.requirement.name = this.documentRequirement.requirement.name.replace(/^(\.|\s)+|(\.|\s)+$/g, "");
    }
    if (this.requirement && this.requirement && this.requirement.name) {
      this.requirement.name = this.requirement.name.replace(/^(\.|\s)+|(\.|\s)+$/g, "");
    }
  }

  public resetForm() {
    // this.requirementService.updateData();
    this.formSubmit.emit({ save: true });
  }

  public isComponentUsedForEditing() {
    return this.documentRequirement && this.documentRequirement.id;
  }

  public isComponentUsedForAdding() {
    return this.documentRequirement && !this.documentRequirement.id;
  }

  public createRequirement() {
    if (!this.isLoading) {
      this.isLoading = true;
      this.sanitizeRequirementName();
      this.requirementControllerService.createRequirement(this.requirement).subscribe(
        (data) => {
          this.requirement = data;
          this.documentRequirement.requirement = this.requirement;
          this.responseSuccessful("Requirement is created!");
          this.saveDocumentRequirement(false);
        },
        (error) => {
          this.isLoading = false;
          this.showErrorMessage(error);
        },
      );
    }
  }

  public updateRequirement() {
    if (!this.isLoading) {
      this.isLoading = true;
      this.sanitizeRequirementName();
      this.requirementControllerService.saveRequirement(this.requirement).subscribe(
        () => {
          this.saveDocumentRequirement();
        },
        (error) => {
          this.isLoading = false;
          this.showErrorMessage(error);
        },
      );
    }
  }

  public submit() {
    if (this.addNew) {
      this.createRequirement();
    } else {
      this.updateRequirement();
    }
  }

  public closeLayer() {
      if (this.addNew && this.requirement.fileId) {
          const cbFn = () => {
              this.editCancel.emit({ cancel: true });
          };
          this.deleteFile(this.requirement, cbFn);
      } else {
          this.editCancel.emit({ cancel: true });
      }
  }

  public closeDetLayer() {
    this.store.state.common.determinantSection.reset();
    // this.editCancel.emit({ cancel: true });
  }

  public printUploadSelected() {
    this.documentRequirement.toPrintUpload = !this.documentRequirement.toPrintUpload;
    if (this.documentRequirement.toPrintUpload) {
      this.documentRequirement.toUpload = false;
      this.documentRequirement.toShow = false;
      this.documentRequirement.toSign = false;
    }
  }

  public changeUploadSettings() {
    if (!this.isFieldDisabled(this.requirement.ownership)) {
      this.documentRequirement.toUpload = !this.documentRequirement.toUpload;
      this.documentRequirement.toPrintUpload = false;
    }
  }

  public changeShowAtFrontDeskSettings() {
    if (!this.isFieldDisabled(this.requirement.ownership)) {
      this.documentRequirement.toShow = !this.documentRequirement.toShow;
      this.documentRequirement.toPrintUpload = false;
    }
  }

  public changeMustBeSignedSettings() {
    if (!this.isFieldDisabled(this.requirement.ownership)) {
      this.documentRequirement.toSign = !this.documentRequirement.toSign;
      this.documentRequirement.toPrintUpload = false;
    }
  }

  public changeMultipleSettings() {
    if (!this.isFieldDisabled(this.requirement.ownership)) {
      this.documentRequirement.multiple = !this.documentRequirement.multiple;
    }
  }

  public changeUsedAsADatabase() {
    if (!this.isFieldDisabled(this.requirement.ownership)) {
      this.documentRequirement.usedAsADatabase = !this.documentRequirement.usedAsADatabase;
    }
  }

  public saveDocumentTypes(types: any[]) {
    this.requirement.types = types;
    this.saveRequirement(this.requirement);
  }

  public addDocumentType(newDocumentType: any) {
    if (newDocumentType && newDocumentType.name) {
      const documentType: DocumentType = new DocumentType();
      documentType.type = newDocumentType.name;
      this.requirement.types.push(documentType);
    }
    this.newDocumentType = "";
  }

  public deleteDocumentType(documentType: DocumentType) {
    this.requirement.types = this.requirement.types.filter((obj) => obj.id !== documentType.id);
  }

  public removeDocumentType(index: any) {
    this.requirement.types.splice(index, 1);
  }

  public showBotSelection(): boolean {
    return this.documentRequirement.toUpload;
  }

  appendDeterminant = (det) => {
    let data = JSON.parse(this.documentRequirement.jsonDeterminants);
    if (!Array.isArray(data)) {
      data = [];
    }
    if (data.length === 0) {
      data.push({
        type: 'OR',
        items: []
      });
    }
    let lastItem = data[data.length - 1];
    if (lastItem.items == null) {
      lastItem = {
        type: 'OR',
        items: []
      };
      data.push(lastItem);
    }
    lastItem.items.push({
      type: det.type || 'OR',
      determinantId: det.determinantId,
    });
    this.documentRequirement.jsonDeterminants = JSON.stringify(data);
  };

  public getTemplateUrl(): string {
    return "document_requirement/" + this.documentRequirement.id + "/template";
  }

  public templateUrlChanged(templateUrl: any) {
    console.log("templateUrlChanged", templateUrl);
    if (templateUrl) {
      this.documentRequirement.templateUrl = templateUrl;
      this.documentRequirement.usedAsADatabase = true;
      this.documentRequirementService.getRegistrationRequirement(this.documentRequirement.id).subscribe(
        (data: any) => {
          console.log("--- getRegistrationRequirement", data);
          this.documentRequirement = data;
          this.documentRequirement.usedAsADatabase = true;
          this.documentRequirementFields = data?.fields || [];
          this.getDocumentFields(this.documentRequirement.id);
          // this.saveDocumentRequirement(false);
        },
        (error) => this.showErrorMessage(error),
      );
    }
  }

  public deleteTemplate(isConfirmed: boolean) {
    if (isConfirmed) {
      return this.http.delete(this.baseUrl + this.getTemplateUrl()).subscribe(() => {
        this.documentRequirement.templateUrl = null;
        this.documentRequirement.aiSchemaName = null;
        this.documentRequirement.aiSchemaDescription = null;
        this.documentRequirementFields = [];
        this.saveDocumentRequirement(false);
      });
    }
  }

}
